import { styled, Box, Typography, DialogContent } from '@mui/material';
import { StyledAddressBoxProps } from 'src/models/DialogBox.interface';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '16px',
  color: 'var(--primary-blue)',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  margin: 0,
}));

export const StyledIcon = styled(Box)(({ theme }) => ({
  fontSize: '30px',
  color: 'var(--primary-blue)',
  marginBottom: theme.spacing(1),
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingBottom: 0,
  flexGrow: 1,
  overflow: 'auto',
  overflowX: 'hidden',
  marginLeft: theme.spacing(6),
  marginRight: theme.spacing(6),
}));

export const StyledAddressBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'boxHeight' && prop !== 'boxWidth',
})<StyledAddressBoxProps>(({ boxHeight, boxWidth }) => ({
  height: boxHeight,
  width: boxWidth,
  backgroundColor: 'var(--readonly-bg)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
  marginBottom: '16px',
  position: 'relative',
}));
export const StyledDialogContainer = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const TopRow = styled(Box)({
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const ContactName = styled(Typography)({
  fontFamily: 'Lufga',
  fontWeight: 500,
  fontSize: '20px',
  color: 'var(--primary-brand-blue)',
  paddingLeft: '20px',
  paddingRight: '20px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const ContactInfo = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '14px',
  color: 'var(--primary-navy)',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '20px',
});

export const PhoneIcon = styled(Box)({
  fontSize: '14px',
  color: 'var(--primary-navy)',
  marginRight: '8px',
});

export const ActionRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginTop: 'auto',
  padding: '8px',
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
}));

export const ActionText = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '14px',
  color: 'var(--subtext)',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
});

export const ActionIcon = styled(Box)({
  fontSize: '16px',
  color: 'var(--subtext)',
  marginRight: '8px',
});

export const AddressGrid = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  gap: '16px',
});

export const AddAddressBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'boxHeight' && prop !== 'boxWidth',
})<StyledAddressBoxProps>(({ boxHeight, boxWidth }) => ({
  height: boxHeight,
  width: boxWidth,
  backgroundColor: 'var(--inactive-btn)',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
  border: '2px dotted var(--primary-blue)',
  marginBottom: '16px',
  cursor: 'pointer',
}));

export const AddressLine = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '12px',
  color: 'var(--primary-navy)',
  paddingLeft: '20px',
});
